import { render, staticRenderFns } from "./OurValuesCard.vue?vue&type=template&id=2bf7a693&"
import script from "./OurValuesCard.vue?vue&type=script&lang=js&"
export * from "./OurValuesCard.vue?vue&type=script&lang=js&"
import style0 from "./OurValuesCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports